import { render, staticRenderFns } from "./BrowserInstructions.vue?vue&type=template&id=794f4724"
import script from "./BrowserInstructions.vue?vue&type=script&lang=js"
export * from "./BrowserInstructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports